export enum FanficStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published',
}

export enum PostStatus {
  IN_PROGRESS = 'in-progress',
  COMPLETED = 'completed',
  FREEZED = 'freezed',
}

export enum BlockStatus {
  ACTIVE = 'active',
  BLOCKED = 'blocked',
  UNBLOCKED = 'unblocked',
}

export type FanficStatusType = FanficStatus.DRAFT | FanficStatus.PUBLISHED;
export type PostStatusType = PostStatus.IN_PROGRESS | PostStatus.COMPLETED | PostStatus.FREEZED;

/** Backend historically used on-hold; some payloads still send that alias. */
export const isFrozenPostStatus = (status?: string) =>
  status === PostStatus.FREEZED || status === 'on-hold' || status === 'frozen';

export const FanficStatusUtils = {
  isPublished: (status: string) => status === FanficStatus.PUBLISHED,
  isDraft: (status: string) => status === FanficStatus.DRAFT,
  isPrivate: (status: string) => status !== FanficStatus.PUBLISHED,
  getDisplayName: (status: string) => {
    switch (status) {
      case FanficStatus.PUBLISHED:
        return 'Опубликовано';
      case FanficStatus.DRAFT:
        return 'Черновик';
      default:
        return 'Черновик';
    }
  },
};

export const BlockUtils = {
  isBlocked: (blockStatus: string) => blockStatus === BlockStatus.BLOCKED,
  isActive: (blockStatus: string) => blockStatus === BlockStatus.ACTIVE,
  isUnblocked: (blockStatus: string) => blockStatus === BlockStatus.UNBLOCKED,
  getBlockDisplayName: () => 'Нарушены правила',
  getBlockMessage: () =>
    'К сожалению, на текущий момент Вы можете загрузить только произведения Джен и Гет направленностей. Другие направленности противоречат актуальным правилам платформы.',
};
